import { render, staticRenderFns } from "./BatchOperationsDialog.vue?vue&type=template&id=0047a842&scoped=true&"
import script from "./BatchOperationsDialog.vue?vue&type=script&lang=js&"
export * from "./BatchOperationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperationsDialog.vue?vue&type=style&index=0&id=0047a842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047a842",
  null
  
)

export default component.exports